import { Component, inject, OnInit } from '@angular/core';
import { RoleService } from '../../services/role.service';
import { SollecitiService } from '../../services/solleciti.service';
import { MessageService } from 'primeng/api';
import { Sollecito } from '../../model/print-data';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-configurazione-sollecito',
  templateUrl: './configurazione-sollecito.component.html',
  styleUrl: './configurazione-sollecito.component.scss'
})
export class ConfigurazioneSollecitoComponent implements OnInit {

  public role_service = inject(RoleService);
  public solleciti_service = inject(SollecitiService);
  private message_service = inject(MessageService);
  private route = inject(ActivatedRoute);

  aggiornamentoSpinner: boolean = false;

  sollecitoForm = new FormGroup({
    annoRiferimento: new FormControl<number|null>(null, Validators.required),
    termineSollecito: new FormControl<Date|null>(null, Validators.required),
    termineSollecitoMultiQuota: new FormControl<Date|null>(null, Validators.required),
    dataConsiglio: new FormControl<Date|null>(null, Validators.required)
  });

  sollecitiStoricoList: Sollecito[] = [];

  ngOnInit(): void {
    const data = this.route.snapshot.data;
    this.loadData(data['sollecitoCorrente'], data['sollecitiList'])
  }

  loadData(sollecitoCorrente: Sollecito, sollecitiList: Sollecito[]){
    this.sollecitoForm.patchValue({
      annoRiferimento: sollecitoCorrente ? sollecitoCorrente.annoRiferimento : new Date().getFullYear(),
      termineSollecito: sollecitoCorrente && sollecitoCorrente.termineSollecito ? new Date(sollecitoCorrente.termineSollecito) : null,
      termineSollecitoMultiQuota: sollecitoCorrente && sollecitoCorrente.termineSollecitoMultiQuota ? new Date(sollecitoCorrente.termineSollecitoMultiQuota) : null,
      dataConsiglio: sollecitoCorrente && sollecitoCorrente.dataConsiglio ? new Date(sollecitoCorrente.dataConsiglio) : null
    });
    this.sollecitiStoricoList = sollecitiList;
  }

  aggiornaSollecito(){
    this.aggiornamentoSpinner = true;

    const formData = this.sollecitoForm.value;

    const sollecitoCorrente: Sollecito = {
      annoRiferimento: formData.annoRiferimento!,
      termineSollecito: formData.termineSollecito ? this.buildDate(formData.termineSollecito) : null,
      termineSollecitoMultiQuota: formData.termineSollecitoMultiQuota ? this.buildDate(formData.termineSollecitoMultiQuota) : null,
      dataConsiglio: formData.dataConsiglio ? this.buildDate(formData.dataConsiglio) : null
    }

    this.solleciti_service.updateSollecitoCorrente(sollecitoCorrente).subscribe({
      next: () => {
        this.message_service.add({ severity: 'success', summary: `Operazione completata`, detail: `Sollecito aggiornato con successo.` });
        this.solleciti_service.getSollecitiLista().subscribe(result => { this.sollecitiStoricoList = result });
      },
      complete: () => {
        this.aggiornamentoSpinner = false;
      },
      error: (err) => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Operazione interrotta.' });
        this.aggiornamentoSpinner = false;
      }
    });
  }

  buildDate(data_in: Date){
    const day = String(data_in.getDate()).padStart(2, '0');
    const month = String(data_in.getMonth() + 1).padStart(2, '0');
    const year = String(data_in.getFullYear());

    const data = `${year}-${month}-${day}`;

    return data;
  }

}
